import {Component, ElementRef, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {ConfigurationService} from "../../../shared/services/configuration.service";
import {ProductService} from "../../../shared/services/product/product.service";
import {AddToCartWidgetConfigModel} from "../../models/add-to-cart-widget-config.model";
import {ProductModel} from "../../../shared/models/product/product.model";
import {WishListService} from "../../../shared/services/product/wish-list-service";

@Component({
    selector: "pcg-ng-wishlist-widget",
    template: require('./wishlist-widget.component.html')
})
export class WishlistWidgetComponent implements OnInit {

    public product: ProductModel;

    private addToWishListSubscription: Subscription;
    private removeFromWishListSubscription: Subscription;

    public constructor(
        productService: ProductService,
        private wishListService: WishListService,
        private domElement: ElementRef,
        private configService: ConfigurationService<AddToCartWidgetConfigModel>
    ) {
        this.configService.initialize(this.domElement.nativeElement.dataset);
        productService
            .getProductById(this.configService.config.productId)
            .subscribe(product => this.product = product);
    }

    public ngOnInit(): void {
        const config = this.configService.config;
    }

    public showButton(): boolean {
        return !this.product.accessioning && !this.product.discontinued;
    }

    public toggleWishListState(): void {
        if (!this.product.inWishList) {
            this.addToWishList();
        } else {
            this.removeFromWishList();
        }
    }

    private addToWishList(): void {
        this.addToWishListSubscription = this.wishListService
            .addToWishList(this.product.id)
            .subscribe(inWishList => this.product.inWishList = inWishList);
    }

    private removeFromWishList(): void {
        this.removeFromWishListSubscription = this.wishListService
            .removeFromWishList(this.product.id)
            .subscribe(inWishList => this.product.inWishList = inWishList);
    }
}
